import React from 'react';
import { useTranslation } from '@app/core/i18n';

import { UsernameFieldFragment } from '@app/common/configurable-wizards/queries/queryTyping/all-fields';
import { combineNames, isUsernameField } from '@app/common/configurable-wizards/utils';
import { FieldComponent, FieldLocator } from '@app/common/configurable-wizards';
import { FormSectionTitle } from '../common/FormSectionTitle';
import { UsernamePolicies } from './UsernamePolicies';
import { UsernameInput } from './UsernameInput';
import styles from './UsernameField.pcss';

const USERNAME_DESCRIPTION_ID = 'new-username-description';

export const NewUsernameFieldComponent: FieldComponent<UsernameFieldFragment> = ({
  parent,
  field,
}) => {
  const { t } = useTranslation();
  const name = combineNames(parent, field.id);
  // Commented.
  // Because was decided to postpone related functionality
  // and release it again with some possible improvements (todo in MPH-40983)
  // const [inputFocused, setInputFocused] = useState(false);

  return (
    (field.fieldBehaviorMode === 'READONLY') ? (
      <div>
        <FormSectionTitle
          title={t('username-field.readonly.title|Readonly field title', 'Account information')}
        />
        <div className={styles.fieldLabelReadonly}>{field.label}</div>
        <div>{field.sValue}</div>
      </div>
    ) : (
      <div>
        <FormSectionTitle
          title={t('username-field.new.title|Create your username - section title', 'Create your username')}
        />

        {/* FIELD SECTION  */}
        <UsernameInput
          field={field}
          fieldName={name}
          aria-describedby={USERNAME_DESCRIPTION_ID}
        // Commented.
        // Because was decided to postpone related functionality
        // and release it again with some possible improvements (todo in MPH-40983)
        // onFocusChange={setInputFocused}
        />

        {/* POLICIES SECTION  */}
        {field.userNamePolicy && (
          <div id={USERNAME_DESCRIPTION_ID}>
            <UsernamePolicies
              policySettings={field.userNamePolicy}
              // Commented.
              // Because was decided to postpone related functionality
              // and release it again with some possible improvements (todo in MPH-40983)
              // relatedInputFocused={inputFocused}
              relatedInputFocused
              fieldName={name}
            />
          </div>
        )}
      </div>
    )
  );
};

export const NewUsernameFieldLocator: FieldLocator = ({ field }) => (
  (isUsernameField(field))
    ? NewUsernameFieldComponent
    : undefined
);
